export default __webpack_public_path__ + "static/media/more-icon.0070cd1b.svg";